export default __webpack_public_path__ + "static/media/nginx.14c0011a.svg";